export type SkinId = "heirloom" | "golden-cherry" | "green-zebra" | "black-krim";

export interface SkinPalette {
  flesh: string;
  fleshHighContrast: string;
  plating: string;
  trim: string;
  accent: string;
  eye: string;
  leaf: string;
  outline: string;
  stripe?: string;
}

export interface Skin {
  id: SkinId;
  name: string;
  unlockBest: number;
  palette: SkinPalette;
}

export const SKINS: readonly Skin[] = [
  { id: "heirloom", name: "HEIRLOOM", unlockBest: 0, palette: {
    flesh: "#b92f24", fleshHighContrast: "#d42418", plating: "#9facb0", trim: "#263d46",
    accent: "#f0aa24", eye: "#68e1ef", leaf: "#365b35", outline: "#111719",
  } },
  { id: "golden-cherry", name: "GOLDEN CHERRY", unlockBest: 1500, palette: {
    flesh: "#e9a32b", fleshHighContrast: "#c77900", plating: "#b8954f", trim: "#493a26",
    accent: "#ffce59", eye: "#68e1ef", leaf: "#365b35", outline: "#111719",
  } },
  { id: "green-zebra", name: "GREEN ZEBRA", unlockBest: 5000, palette: {
    flesh: "#8cab45", fleshHighContrast: "#64851c", plating: "#bd8057", trim: "#3c4930",
    accent: "#edb14e", eye: "#68e1ef", leaf: "#365b35", outline: "#111719", stripe: "#365b35",
  } },
  { id: "black-krim", name: "BLACK KRIM", unlockBest: 12000, palette: {
    flesh: "#622c49", fleshHighContrast: "#4c183c", plating: "#c3cbd1", trim: "#303643",
    accent: "#e6aa59", eye: "#ff70d7", leaf: "#365b35", outline: "#111719",
  } },
];

export function unlockedSkins(bestScore: number): Skin[] {
  return SKINS.filter(skin => bestScore >= skin.unlockBest);
}

export function isSkinUnlocked(id: unknown, bestScore: number): id is SkinId {
  return SKINS.some(skin => skin.id === id && bestScore >= skin.unlockBest);
}

export function newlyUnlockedSkins(previousBest: number, newBest: number): Skin[] {
  return SKINS.filter(skin => previousBest < skin.unlockBest && newBest >= skin.unlockBest);
}
